import { useCallback, useMemo, useState } from 'react';
import Modal from '@components/common/Modal';
import { TouchableButton } from '@components/common/Touchable';
import { CUSTOM_MESSAGES, LABEL } from '@veriables';
import cn from 'classnames';
import styles from './cart.module.scss';

const getMessage = (type, count) => {
  switch (type) {
    case 'deleteAll':
      return count === 1
        ? CUSTOM_MESSAGES().SINGLE_DELETE_MSG
        : CUSTOM_MESSAGES().DELETE_ALL_UNSENT_MSG;
    case 'deleteSelected':
      return count === 1
        ? CUSTOM_MESSAGES().SINGLE_SELECTED_DELETE_MSG
        : CUSTOM_MESSAGES().MULTIPLE_DELETE_MSG;
    case 'deleteRow':
      return CUSTOM_MESSAGES().SINGLE_SELECTED_DELETE_MSG;
    case 'sendRow':
      return CUSTOM_MESSAGES().SINGLE_SEND_MSG;
    case 'sendAll':
      return count === 1
        ? CUSTOM_MESSAGES().SINGLE_SEND_MSG
        : CUSTOM_MESSAGES().SEND_ALL_UNSENT_MSG;
    case 'sendSelected':
      return count === 1
        ? CUSTOM_MESSAGES().SINGLE_SELECTED_SEND_MSG
        : CUSTOM_MESSAGES().MULTIPLE_SEND_MSG;
    case 'voidSelected':
      return CUSTOM_MESSAGES().SENT_VOID;
    case 'voidRow':
      return CUSTOM_MESSAGES().SENT_VOID;
    default:
      return '';
  }
};

export const useConfirmFooterModal = ({
  onDeleteAll,
  onDeleteSelected,
  onDeleteRow,
  onSendAll,
  onSendSelected,
  onSendRow,
  onVoidSelected,
  onVoidRow,
  serverAppTheme,
}) => {
  const [state, setState] = useState({ open: false, type: null, count: 0, data: null });

  const close = useCallback(
    (e) => {setState({ open: false, type: null, count: 0, data: null }); e.preventDefault();
},
  []
  );

  const request = useCallback((type, count, data = null) => {
    setState({ open: true, type, count, data });
  }, []);

  const onYes = useCallback((e) => {
    switch (state.type) {
      case 'deleteAll':
        onDeleteAll?.();
        break;
      case 'deleteSelected':
        onDeleteSelected?.();
        break;
      case 'deleteRow':
        onDeleteRow?.(state.data);
        break;
      case 'sendRow':
        onSendRow?.(state.data);
        break;
      case 'sendAll':
        onSendAll?.();
        break;
      case 'sendSelected':
        onSendSelected?.();
        break;
      case 'voidSelected':
        onVoidSelected?.();
        break;
      case 'voidRow':
        onVoidRow?.(state.data);
        break;
      default:
        break;
    }
    close(e);
  }, [
    state.type,
    state.data,
    onDeleteAll,
    onDeleteSelected,
    onDeleteRow,
    onSendAll,
    onSendSelected,
    onSendRow,
    onVoidSelected,
    onVoidRow,
    close,
  ]);

  const ConfirmationPopUpStyle = useMemo(() => {
    const optionsPopUp = {
      backgroundColor: serverAppTheme?.popUp_bg,
      borderRadius: '16px',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
      width: '486px',
      margin: 'auto',
      minHeight: '216px',
      padding: '1.5rem',
      position: 'relative',
    };
    const primText = {
      color: serverAppTheme ? serverAppTheme?.primary_text : 'white',
    };
    const noButton = {
      border: serverAppTheme?.cancleBtn_Border,
      background: serverAppTheme?.OFF_Premise_Btn,
      color: serverAppTheme?.cancleBtn_font,
    };
    const yesButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
    };
    return { optionsPopUp, primText, noButton, yesButton };
  }, [serverAppTheme]);

  const jsx = (
    <Modal
      isOpen={state.open}
      isModalCenter
      style={ConfirmationPopUpStyle.optionsPopUp}
      customClass="h-100 w-100"
      customClass2="h-100 w-100 my-0"
    >
      <div
        className="justify-content-center align-items-center text-center h-100"
        style={ConfirmationPopUpStyle.primText}
      >
        <div className="col-12 p-0 h-70 justify-content-center d-flex flex-column">
          <div className="col-12 fs_18 fw-700 text-center h-auto">
            Are You Sure ?
          </div>
          <br />
          <div className="col-12 px-0 fs_15 fw-400 text-center h-auto">
            {getMessage(state.type, state.count)}
          </div>
        </div>
        <br />
        <div
          style={{ bottom: '1rem', left: '0' }}
          className="col-12 px-4 h-30 d-flex mt-auto justify-content-center align-items-center text-center position-absolute"
        >
          <div className="col-6 pl-0 pr-1">
            <TouchableButton
              className={cn(styles.btnSecondary, 'col-12 fs_24 fw-600')}
              style={ConfirmationPopUpStyle.noButton}
              type="button"
              onClick={(e) => close(e)}
            >
              {LABEL().NO}
            </TouchableButton>
          </div>
          <div className="col-6 pl-1 pr-0">
            <TouchableButton
              className={cn(styles.btnPrimary, 'col-12 btn-ripple fs_24 fw-600')}
              style={ConfirmationPopUpStyle.yesButton}
              type="button"
              onClick={(e) => onYes(e)}
            >
              {LABEL().YES}
            </TouchableButton>
          </div>
        </div>
      </div>
    </Modal>
  );

  return { request, jsx };
};
